export default __webpack_public_path__ + "static/header-title-do-dark-e9a8386d21882aa5d78115d156ccd610.png";